import {tr} from '@/i18n/copy';

export const hasOfferDeposit = offer => Number(offer?.deposit_amount) > 0;

export default function ClientOfferDeposit({offer,currency}) {
  if(!hasOfferDeposit(offer))return null;
  return <section className="my-3 rounded-xl border border-primary/50 bg-primary/10 p-4" aria-label={tr('Acconto richiesto')}>
    <p className="font-semibold">{tr('Acconto richiesto: {{0}} {{1}}', {0:currency,1:Number(offer.deposit_amount).toFixed(2)})}</p>
    <p className="mt-2 text-sm">{tr('Accettando ti impegni a versare questo acconto per confermare la prenotazione. È incluso nel prezzo totale, non è un costo aggiuntivo.')}</p>
    <p className="mt-2 text-sm">{tr(offer.deposit_deadline_at_start ? 'Dopo l’accettazione dovrai versarlo entro 24 ore e comunque prima dell’appuntamento. Troverai le modalità di pagamento e la scadenza negli appuntamenti.' : 'Dopo l’accettazione avrai 24 ore per versarlo. Troverai le modalità di pagamento e la scadenza negli appuntamenti.')}</p>
  </section>;
}
